import api from '../../api/_base_assurance'

const state = () => ({
    base_assurs: ''
})

// getters
const getters = {
    base_assurs: (state) => {
        return state.base_assurs
    },
}

// mutations
const mutations = {
    SET_BASE_ASSURS(state, base) {
        state.base_assurs = base
    },
}

// actions
const actions = {
    /**
     * Ajouter la base assurance d;un medicament
     * @param {*} param0 
     * @param {*} data 
     * @returns 
     */
    addBaseAssurance({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.addBaseAssurance(data).then(
                response => {
                    dispatch('getBaseAssurance', data.medicament_id)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getBaseAssurance({ commit }, medicament_id) {
        return new Promise((resolve, reject) => {
            api.getBaseAssurance(medicament_id).then(
                response => {
                    commit('SET_BASE_ASSURS', response)
                    resolve(response)

                }, error => {
                    reject(error)
                }
            )
        })
    },
    
    deleteBaseAssurance({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.deleteBaseAssurance(data).then(
                response => {
                    dispatch('getBaseAssurance', data.medicament_id)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
}

export default {
  state,
  getters,
  mutations,
  actions
}